import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Move = createReactComponent("Move", ["svg", defaultAttributes, [["polyline", {
  points: "5 9 2 12 5 15",
  key: "1v65fw"
}], ["polyline", {
  points: "9 5 12 2 15 5",
  key: "1aef3b"
}], ["polyline", {
  points: "15 19 12 22 9 19",
  key: "1e6jgb"
}], ["polyline", {
  points: "19 9 22 12 19 15",
  key: "11lfqd"
}], ["line", {
  x1: "2",
  y1: "12",
  x2: "22",
  y2: "12",
  key: "1vcgga"
}], ["line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "22",
  key: "1hqhh2"
}]]]);
export default Move;